module.exports = __webpack_public_path__ + "static/img/10020 (3).41def08.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10020 (3).webp
// module id = h2hG
// module chunks = 14